<template>
  <PanelItem
    :index="index"
    :field="field"
  >
    <template #value>

      <div v-if="field.value.length === 0">
        <span class="text-gray-500">{{ __('No items') }}</span>
      </div>
      <div class="flex flex-wrap gap-2" v-else>
        <div  v-for="(item, index) in field.value" :key="item[valueKey]">
          {{ item[labelKey] }}
          <span v-if="index !== field.value.length - 1">, </span>
        </div>
      </div>
    </template>
  </PanelItem>
</template>

<script>
export default {
	props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],


  computed: {
    labelKey() {
      return this.field.labelKey ?? 'full_name';
    },
    valueKey() {
      return this.field.valueKey ?? 'id';
    }
  }
}
</script>